import { render, staticRenderFns } from "./LinkAddTask.vue?vue&type=template&id=48acdeb6&scoped=true&"
import script from "./LinkAddTask.vue?vue&type=script&lang=tsx&"
export * from "./LinkAddTask.vue?vue&type=script&lang=tsx&"
import style0 from "./LinkAddTask.vue?vue&type=style&index=0&id=48acdeb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48acdeb6",
  null
  
)

export default component.exports